var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.platform.isPC)?_c('HeaderPc'):_c('HeaderM',{ref:"header"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }